import {UserNotificationPreferencesService} from "./preferences/UserNotificationPreferencesService";
import {UserNotificationPreferencesDialogService} from "./preferences-dialog/UserNotificationPreferencesDialogService";
import {LowPriorityNotificationService} from "./popup/LowPriorityNotificationService";
import {HighPriorityNotificationService} from "./popup/HighPriorityNotificationService";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/services`;

    return angular.module("tfApp.notifications.services", [])
                  .service(UserNotificationPreferencesService.id, UserNotificationPreferencesService)
                  .service(UserNotificationPreferencesDialogService.id, UserNotificationPreferencesDialogService)
                  .service(HighPriorityNotificationService.id, HighPriorityNotificationService)
                  .service(LowPriorityNotificationService.id, LowPriorityNotificationService)
                  .name;
}
